import { MotionProps } from 'framer-motion';

const fadeInOut = (duration = 0.3): MotionProps => {
    return {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        transition: { duration },
    };
};

const slideUpDown = (duration = 0.2): MotionProps => {
    return {
        initial: { y: 500 },
        animate: { y: 0 },
        exit: { y: 500 },
        transition: { duration, ease: "linear" },
    };
};

const animations = { fadeInOut, calendar: fadeInOut(0.1), slideUpDown };

export default animations;
